import axios from 'axios'
import { DocumentTypes } from 'client/Interfaces/Draft/DraftInterface'

import { getRequestConfig } from './index'

export interface DeliveryResponseInterface {
  success: boolean
  message: string
}

async function sendPremiumInvoice(
  id: number,
  type: string,
  documentType: DocumentTypes,
  body?: { attachmentUuids?: string[]; isPublicEntity?: boolean },
) {
  const header = {
    'Content-Type': 'application/json',
  }
  const url = type === 'paper' ? `/invd/v3/paper/${documentType}/${id}` : `/invd/v3/${type}/${documentType}/${id}`
  let result: DeliveryResponseInterface
  try {
    const response = await axios.post(url, body, getRequestConfig(header))
    result = {
      success: response.status === 200,
      message: response.data,
    }
  } catch (e) {
    result = {
      success: false,
      message: e.type,
    }
  }
  return result
}

export async function sendPaperInvoice(id: number) {
  return sendPremiumInvoice(id, 'paper', DocumentTypes.INVOICE, {})
}

export async function sendEInvoice(
  id: number,
  attachmentUuids: string[] = [],
  isPublicEntity,
  documentType: DocumentTypes = DocumentTypes.INVOICE,
) {
  return sendPremiumInvoice(id, 'einvoice', documentType, { attachmentUuids, isPublicEntity })
}
